/* eslint-disable max-len */
import { downloadElement } from 'util/download-element';
import { getUserId } from 'util/auth';
import { notification } from 'antd';
import i18n from 'i18next';
import {
  DATA_EXPORT_REQUEST,
  DATA_EXPORT_SUCCESS,
  DATA_EXPORT_FAIL
} from './action';
import * as mutations from './mutations';
import * as subscription from './subscription';

export function exportCleaningReport(payload) {
  const {
    exportType,
    exportColumns,
    filters,
    rowValueTranslation,
    measurementFormat
  } = payload;

  return async (dispatch, _, { client }) => {
    try {
      dispatch({ type: DATA_EXPORT_REQUEST });
      const userId = await getUserId();

      const clientResponse = await client.mutate({
        mutation: mutations.commandExportingCleaningReports,
        variables: {
          input: {
            filter: filters,
            exportType,
            exportColumns,
            rowValueTranslation,
            measurementFormat,
            // multiple by -1 because it returns negative if the local time zone is ahead of UTC and vice versa
            // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Date/getTimezoneOffset#negative_values_and_positive_values
            timezoneOffsetInMinutes: new Date().getTimezoneOffset() * -1
          }
        }
      });

      const requestToken =
        clientResponse?.data?.commandExportingCleaningReports;

      const observableInstance = client.subscribe({
        query: subscription.subscribeCleaningReportsFileExported,
        variables: {
          userId,
          requestToken
        }
      });

      observableInstance.subscribe((response) => {
        const fileUrls =
          response?.data?.subscribeCleaningReportsFileExported?.fileUrls || [];

        fileUrls.forEach((fileUrl) => downloadElement(fileUrl));
      });

      notification.info({
        message: i18n.t('exportCleaningReport.notification.loadingMessage'),
        top: 70,
        duration: 10
      });

      dispatch({
        type: DATA_EXPORT_SUCCESS
      });
    } catch (error) {
      dispatch({ type: DATA_EXPORT_FAIL });
    }
  };
}
